import React, { ReactNode } from 'react';

import { Surface } from '@infoods/lifebase-ui';

import classes from './EmptyListWrapper.module.scss';

type EmptyListWrapperVariant = 'paper' | 'plain';

type EmptyListWrapperProps = {
  children: ReactNode;
  variant: EmptyListWrapperVariant;
};

const EmptyListWrapper = ({ children, variant }: EmptyListWrapperProps) => {
  switch (variant) {
    case 'paper':
      return <Surface>{children}</Surface>;
    case 'plain':
      return <div className={classes.emptyListWrapper}>{children}</div>;
  }
};

export { EmptyListWrapper, EmptyListWrapperVariant };
